import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useWorkplaceBlocked(refetchData) {
  const loading = ref(false)
  const workplaceBlockedModal = ref(null)

  const workplaceBlocked = ref({
    workplace_id: null,
    workplace_name: null,
    blocked_at: '',
  })

  function show(workplace) {
    workplaceBlocked.value.workplace_id = workplace.id
    workplaceBlocked.value.workplace_name = workplace.name
    workplaceBlocked.value.blocked_at = workplace.blocked_at
    workplaceBlockedModal.value.show()
  }

  function blockRelease() {
    loading.value = true
    const payload = {
      workplaceId: workplaceBlocked.value.workplace_id,
      blockedAt: workplaceBlocked.value.blocked_at,
    }
    store.dispatch('app-institution/blockRelease', payload)
      .then(() => {
        refetchData()
        loading.value = false
        workplaceBlockedModal.value.hide()
      }).catch(() => {
        loading.value = false
      })
  }

  return {
    loading,
    workplaceBlockedModal,
    workplaceBlocked,
    show,
    blockRelease,
  }
}
